import { render } from "./NetPromoterScore.vue?vue&type=template&id=16123c21"
import script from "./NetPromoterScore.vue?vue&type=script&lang=js"
export * from "./NetPromoterScore.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__